import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useFlow } from '@/hooks/useFlow';
import { useAnalytics } from '@/hooks/useAnalytics';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { Button } from '@/components/ui/button';

export function BuyButtonFlow() {
  const { flowId } = useParams<{ flowId: string }>();
  const { flow, isLoading, error } = useFlow(flowId);
  const { trackEvent } = useAnalytics();
  const navigate = useNavigate();

  useEffect(() => {
    if (flow) {
      trackEvent({
        name: 'view',
        properties: {
          flowId: flow.id,
          flowType: 'buy_button',
          pageType: 'buy_button',
        },
      });
    }
  }, [flow, trackEvent]);

  const handlePurchaseClick = () => {
    if (flow) {
      trackEvent({
        name: 'click',
        properties: {
          flowId: flow.id,
          flowType: 'buy_button',
          action: 'purchase',
        },
      });
      navigate(`/payment/${flowId}`);
    }
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error || !flow) {
    return <div>Error loading flow</div>;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mb-6 text-4xl font-bold text-foreground">
          {(flow as any)?.buy_button_heading || flow?.product_name || "Exclusive Offer"}
        </h1>
        <p className="mb-8 text-lg text-muted-foreground">
          {(flow as any)?.buy_button_description || "Don't miss out on this amazing opportunity. Click below to proceed with your purchase."}
        </p>
        <Button
          size="lg"
          onClick={handlePurchaseClick}
          className="animate-pulse hover:animate-none"
        >
          {(flow as any)?.buy_button_cta_text || "Buy Now"}
        </Button>
      </div>
    </div>
  );
} 